import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import './Download.css';
// 导入图片资源
import leftImage from '../../assets/left.png';
import centerImage from '../../assets/lanjing2.png';
import rightImage from '../../assets/right.png';
import { useStore } from '../../store';
import { message, Tooltip } from 'antd';
import { downloadItems, renderIcon } from './constants';
import { bindUserRelation } from '../../services/api';
// import { detectOS } from '../../utils/platform';
import { getQueryString } from '../../utils/url';

const Download: React.FC = () => {
  const { userInfo } = useStore();
  const location = useLocation();
  const [messageApi, contextHolder] = message.useMessage();
  const hasBindRef = useRef(false);
  const userCodeRef = useRef<string | null>(null);
  // const hasAutoDownloadRef = useRef(false);

  // 获取并保存inviterCode
  useEffect(() => {
    userCodeRef.current = getQueryString('usercode');
    console.log('userCodeRef.current=====', userCodeRef.current);
  }, [location.hash]);

  // 自动检测系统并下载
  // 0917临时禁用自动下载
  // const autoDownload = useCallback(() => {
  //   // 如果已经触发过自动下载，则不再触发
  //   if (hasAutoDownloadRef.current) {
  //     return;
  //   }

  //   // 检测操作系统类型
  //   const osType = detectOS();
  //   console.log('osType=====', osType);

  //   // 查找对应的下载项
  //   const downloadItem = downloadItems.find(item => item.icon === osType);

  //   if (downloadItem?.status === 'available' && downloadItem.downloadUrl) {
  //     // 标记已触发自动下载
  //     hasAutoDownloadRef.current = true;

  //     // 显示下载提示
  //     messageApi.open({
  //       content: `已启动下载，如果下载行为被浏览器拦截，请选择保留或允许。`,
  //       type: 'info',
  //       duration: 10
  //     });

  //     // 延迟1秒后开始下载，给用户看到提示的时间
  //     setTimeout(() => {
  //       window.open(downloadItem.downloadUrl, '_blank');
  //     }, 800);
  //   }
  // }, [messageApi]);

  // 处理用户绑定关系
  const handleUserBinding = useCallback(async () => {
    // 如果已经处理过绑定或没有邀请码，直接返回
    if (!userCodeRef.current || hasBindRef.current || !userInfo?.userName) {
      if (!userCodeRef.current) {
        // autoDownload();
      }
      return;
    }

    try {
      hasBindRef.current = true; // 标记已经处理过绑定
      const result = await bindUserRelation(userCodeRef.current!);
      console.log('result=====', result);
      if (result.code === 0) {
        if (result.data === 1) {
          messageApi.success('已接受邀请并下载客户端，安装客户端并登录之后邀请生效！');
        } else if (result.data === 2) {
          messageApi.open({
            content: '您已接受过其他用户的邀请。安装最新版客户端并登录使用吧！',
            type: 'error',
            duration: 10
          })
        } else {
          // messageApi.info('活动已失效')
        }
      }
    } catch (error) {
      console.error('绑定关系时发生错误:', error);
      // messageApi.error('活动已失效');
      // 如果发生错误，重置绑定状态，允许重试
      hasBindRef.current = false;
    } finally {
      // autoDownload();
    }
  }, [userInfo?.userName, messageApi, userCodeRef]);

  useEffect(() => {
    handleUserBinding();
  }, [handleUserBinding]);


  const handleDownload = (item: typeof downloadItems[number]): void => {
    if (item.status === 'building') {
      return;
    }
    if (item.status === 'available' && item.downloadUrl) {
      window.open(item.downloadUrl, '_blank');
    }
  };

  return (
    <>
      {contextHolder}
      <div className="download-container">
        {/* 页面头部 */}
        <div className="download-header">
          <h1>小海 - AI办公智能助手</h1>
          <p>我是海尔集团的AI办公智能助手，可以为您提供智能问答、场景办理、内容推荐、内容创作等服务，等您来体验~</p>
          <br />
          <p style={{
              fontWeight: 'bold',
              fontFamily: 'PingFang SC',
              fontSize: '22px',
              color: '#ffffff',
              backgroundColor: 'blueviolet',
          }}>iHaier智能助手已全新升级为"小海客户端"，请下载并开启你的AI办公之旅吧</p>
        </div>

        {/* AI助手形象区域 */}
        <div className="ai-assistant-section">
          <div className='ai-assistant-banner'>
            <img src={leftImage} alt="AI助手左侧装饰" />
            <img src={centerImage} alt="AI助手中心形象" />
            <img src={rightImage} alt="AI助手右侧装饰" />
          </div>
        </div>

        {/* 下载选项 */}
        <div className="download-options">
          {downloadItems.map((item) => (
            <Tooltip
              key={item.id}
              title={item.toolTip}
              placement="top"
              overlayClassName="download-tooltip"
            >
              <div
                className={`download-card ${item.status}`}
                onClick={() => handleDownload(item)}
              >
                {renderIcon(item.icon)}
                <div className="download-name">
                  {item.name}{item.status === 'available' ? '' : '构建中'}
                </div>
              </div>
            </Tooltip>
          ))}
        </div>
      </div>
    </>
  );
};

export default Download; 